var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDuplicateIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.666 10.667V6.93366C10.666 5.44019 10.666 4.69345 10.9567 4.12302C11.2123 3.62125 11.6203 3.2133 12.122 2.95764C12.6925 2.66699 13.4392 2.66699 14.9327 2.66699H25.066C26.5595 2.66699 27.3062 2.66699 27.8767 2.95764C28.3784 3.2133 28.7864 3.62125 29.042 4.12302C29.3327 4.69345 29.3327 5.44019 29.3327 6.93366V17.067C29.3327 18.5605 29.3327 19.3072 29.042 19.8776C28.7864 20.3794 28.3784 20.7873 27.8767 21.043C27.3062 21.3337 26.5595 21.3337 25.066 21.3337H21.3327M6.93268 29.3337H17.066C18.5595 29.3337 19.3062 29.3337 19.8767 29.043C20.3784 28.7873 20.7864 28.3794 21.042 27.8776C21.3327 27.3072 21.3327 26.5605 21.3327 25.067V14.9337C21.3327 13.4402 21.3327 12.6934 21.042 12.123C20.7864 11.6213 20.3784 11.2133 19.8767 10.9576C19.3062 10.667 18.5595 10.667 17.066 10.667H6.93268C5.43921 10.667 4.69247 10.667 4.12204 10.9576C3.62028 11.2133 3.21233 11.6213 2.95666 12.123C2.66602 12.6934 2.66602 13.4402 2.66602 14.9337V25.067C2.66602 26.5605 2.66602 27.3072 2.95666 27.8776C3.21233 28.3794 3.62028 28.7873 4.12204 29.043C4.69247 29.3337 5.43921 29.3337 6.93268 29.3337Z",
    stroke: "#147AF3",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicateIcon);
export default __webpack_public_path__ + "static/media/duplicateIcon.e37aca432dfb7254680d8088b5f059d5.svg";
export { ForwardRef as ReactComponent };